import React, { useState, useEffect } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import WhyChooseUs from './components/WhyChooseUs';
import TargetClients from './components/TargetClients';
import Process from './components/Process';
import Testimonials from './components/Testimonials';
import Resources from './components/Resources';
import Footer from './components/Footer';
import { Routes, Route, useLocation } from 'react-router-dom';
import ServiceDetailPage from './components/ServiceDetailPage';
import './App.css';

function App() {
  const [activeServiceTab, setActiveServiceTab] = useState(null);
  const location = useLocation();

  const handleServiceClick = (serviceId) => {
    setActiveServiceTab(serviceId);
  };

  // Handle clean URL navigation for all sections
  useEffect(() => {
    const path = location.pathname;
    const sectionId = path === '/' ? 'home' : path.replace('/', '');
    
    const attemptScroll = () => {
      const targetSection = document.getElementById(sectionId);
      if (targetSection) {
        const headerHeight = 100; // Approximate header height
        const elementPosition = targetSection.offsetTop - headerHeight;
        window.scrollTo({
          top: elementPosition,
          behavior: 'smooth'
        });
      } else {
        // If not yet rendered, try again shortly
        setTimeout(attemptScroll, 100);
      }
    };
    
    // Only scroll if we're on the home page or a valid section
    if (path === '/' || ['home', 'about', 'services', 'process', 'contact'].includes(sectionId)) {
      attemptScroll();
    }
  }, [location]);

  return (
    <div className="App">
      <Header onServiceClick={handleServiceClick} />
      <Routes>
        <Route
          path="/"
          element={(
            <>
              <Hero />
              <Services initialTab={activeServiceTab} />
              <WhyChooseUs />
              <TargetClients />
              <Process />
              <Testimonials />
              <Resources />
              <Footer />
            </>
          )}
        />
        <Route
          path="/home"
          element={(
            <>
              <Hero />
              <Services initialTab={activeServiceTab} />
              <WhyChooseUs />
              <TargetClients />
              <Process />
              <Testimonials />
              <Resources />
              <Footer />
            </>
          )}
        />
        <Route
          path="/about"
          element={(
            <>
              <Hero />
              <Services initialTab={activeServiceTab} />
              <WhyChooseUs />
              <TargetClients />
              <Process />
              <Testimonials />
              <Resources />
              <Footer />
            </>
          )}
        />
        <Route
          path="/services"
          element={(
            <>
              <Hero />
              <Services initialTab={activeServiceTab} />
              <WhyChooseUs />
              <TargetClients />
              <Process />
              <Testimonials />
              <Resources />
              <Footer />
            </>
          )}
        />
        <Route
          path="/process"
          element={(
            <>
              <Hero />
              <Services initialTab={activeServiceTab} />
              <WhyChooseUs />
              <TargetClients />
              <Process />
              <Testimonials />
              <Resources />
              <Footer />
            </>
          )}
        />
        <Route
          path="/contact"
          element={(
            <>
              <Hero />
              <Services initialTab={activeServiceTab} />
              <WhyChooseUs />
              <TargetClients />
              <Process />
              <Testimonials />
              <Resources />
              <Footer />
            </>
          )}
        />
        <Route path="/services/:serviceId" element={<ServiceDetailPage />} />
      </Routes>
    </div>
  );
}

export default App;
